import { LOADING } from "../Constants";

export const loading = (obj) => {
  return { type: LOADING, payload: obj };
};
